import { gql } from "@apollo/client";

export const GET_LAN_CONTROLLER_LOGS = gql`
  query ControllerLogs($domain: String!, $lancontrollerid: Int!, $starttime: Long!, $endtime: Long!) {
    controller {
      logs(domain: $domain, lancontrollerid: $lancontrollerid, starttime: $starttime, endtime: $endtime) {
        lan_controller_log_id
        fk_lan_controllers
        timestamp
        level
        type
        message
        fk_terminals
        fk_animals
      }
    }
  }
`

export interface LanControllerLogParameters {
  domain: string;
  lancontrollerid: number;
  starttime: number;
  endtime: number;
}
export interface LanControllerLogArgs {
  fk_lan_controllers: number;
  lan_controller_log_id: number;  
  message: string;
  timestamp: number;
  level: number;
  type: number;
  fk_terminals?: number;
  fk_animals?: number;
}

export interface LanControllerLogResponse {
  controller: {
    logs: LanControllerLogArgs[]
  } 
}